import { render, staticRenderFns } from "./Noside.vue?vue&type=template&id=0a65cb2d&scoped=true"
import script from "./Noside.vue?vue&type=script&lang=js"
export * from "./Noside.vue?vue&type=script&lang=js"
import style0 from "./Noside.vue?vue&type=style&index=0&id=0a65cb2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a65cb2d",
  null
  
)

export default component.exports